import { render, staticRenderFns } from "./FaPieChartComponent.vue?vue&type=template&id=36a0061c&scoped=true&"
import script from "./FaPieChartComponent.vue?vue&type=script&lang=js&"
export * from "./FaPieChartComponent.vue?vue&type=script&lang=js&"
import style0 from "./FaPieChartComponent.vue?vue&type=style&index=0&id=36a0061c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a0061c",
  null
  
)

export default component.exports